// extracted by mini-css-extract-plugin
export default {"link":"BK-z","disabled":"CK-z"};